module.exports = __webpack_public_path__ + "static/media/container3.1bbe7b59.jpg";